<template>
  <div id="header2">
    <!-- Nav -->
    <nav id="nav">
      <img
        class="imagetran"
        src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/36571d0c027841b6a16ad96fa941f355.png"
        alt=""
        @click="goLink('Home')"
      />
      <ul>
        <li
          :class="currentRouteName == 'Home' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'Home' ? '100%' : '0',
          }"
        >
          <router-link to="/">
            <a> 首页</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'policy' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'policy' ? '100%' : '0',
          }"
        >
          <router-link to="/policy">
            <a>政策法规</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'vipBox' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'vipBox' ? '100%' : '0',
          }"
        >
          <router-link to="/vipBox">
            <a>会员单位</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'newBox' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'newBox' ? '100%' : '0',
          }"
        >
          <router-link to="/newBox">
            <a>新闻动态</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'contact' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'contact' ? '100%' : '0',
          }"
        >
          <router-link to="/contact">
            <a> 联系我们</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'About' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'About' ? '100%' : '0',
          }"
        >
          <router-link to="/About">
            <a>关于协会</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'signUp' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'signUp' ? '100%' : '0',
          }"
        >
          <router-link to="/signUp">
            <a> 护工培训</a>
          </router-link>
        </li>
        <li
          :class="currentRouteName == 'zhaogong' ? 'linkactive' : ''"
          :style="{
            '--after-width': currentRouteName == 'zhaogong' ? '100%' : '0',
          }"
        >
          <router-link to="/zhaogong">
            <a> 招工需求</a>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      currentRouteName: '',
    };
  },
  created() {
    this.currentRouteName = this.$route.name;
  },
  watch: {
    '$route'(to) {
      this.currentRouteName = to.name;
    }
  },
  methods: {
    goLink(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style scoped>
#header2 {
  width: 100%;
}

#nav {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 1;
  overflow: hidden;
  background-color: #F6F9FD;
  align-items: center;
  position: fixed;
  padding: 0 18em;
}

#nav > .imagetran {
  width: 203px;
  height: 49px;
  cursor: pointer;
}

#nav > ul {
  line-height: 80px;
  position: relative;
  display: inline-block;
  margin: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#nav > ul:after {
  right: 100%;
  margin-right: 1px;
}

#nav > ul > li {
  display: inline-block;
  margin: 0px 1em 0 1em;
  border: solid 1px transparent;
  -moz-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -webkit-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -ms-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  color: #333;
}

#nav > ul > li > a,
#nav > ul > li > span {
  display: block;
  color: inherit;
  text-decoration: none;
  border: 0;
  outline: 0;
}

#nav > ul > li > a {
  display: block;
  color: #222222;
  text-align: center;
  text-decoration: none;
  position: relative;
  font-size: 0.75em;
}

#nav > ul > li > a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: var(--after-width, 0);
  height: 4px;
  background-color: #0BA29A;
  color: #0BA29A;
  transition: width 0.1s ease;
}

#nav > ul > li > a:hover::after {
  width: 100%;
}

#nav > ul > li > a:hover {
  color: #0BA29A;
  font-weight: 600;
}

.linkactive {
  color: #0ba29a !important;
  font-weight: 600;
}

#nav > ul > li > a.current-page {
  color: #0BA29A;
  font-weight: 600;
}

#nav > ul > li > ul {
  display: none;
}

@media screen and (max-width: 1680px) {
  #nav {
    padding: 0 10em;
  }
}

@media screen and (max-width: 1280px) {
  #nav {
    padding: 0 10em;
  }
}

@media screen and (max-width: 840px) {
  #nav {
    padding: 0 60px;
  }
  
  #nav > .imagetran {
    width: 150px;
    height: 36px;
  }
  
  #nav > ul > li {
    margin: 0px 0.5em 0 0.5em;
  }
  
  #nav > ul > li > a {
    font-size: 0.65em;
  }
}

@media screen and (max-width: 736px) {
  #nav {
    padding: 0 30px;
  }
  
  #nav > .imagetran {
    width: 120px;
    height: 29px;
  }
  
  #nav > ul {
    display: none;
  }
}
</style>
